import { render, staticRenderFns } from "./youtube.vue?vue&type=template&id=d8230364"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8230364')) {
      api.createRecord('d8230364', component.options)
    } else {
      api.reload('d8230364', component.options)
    }
    module.hot.accept("./youtube.vue?vue&type=template&id=d8230364", function () {
      api.rerender('d8230364', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/youtube.vue"
export default component.exports